// extracted by mini-css-extract-plugin
export default {"slide":"style_slide__xgXmx","blur":"style_blur__e2JuI","avatar":"style_avatar__rHg5U","quote":"style_quote__CdvNk"};